
const {mk} = require('./utils/misc');

document.querySelectorAll('h2').forEach((h2, i) => {
    const text = h2.innerText;
    const cleanText = text.replace(/[^a-z0-9]+/ig, '-').toLowerCase();
    const anchorId = `h2-${cleanText}`;
    h2.innerText = '';
    const anchor = mk('a', h2);
    anchor.href = `#${anchorId}`;
    anchor.id = anchorId;
    anchor.innerText = text;
});

